// 'modal-health-alert
document.addEventListener('DOMContentLoaded', () => {
    const modal_health_alert = document.getElementById('modal-health-alert');

    const cancelBtn  = modal_health_alert.querySelector('#cancelBtn');
    const confirmBtn = modal_health_alert.querySelector('#confirmBtn');

    const /** @type Modal */ m = window.Modal.getOrCreateInstance(modal_health_alert);

    // İptal → refresh
    cancelBtn.addEventListener('click', (e) => {
        e.preventDefault();
        location.reload();
    });

    // Onaylıyorum → modal hide
    confirmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        m.hide();
    });
});